import { render, staticRenderFns } from "./header-bread-crumb.vue?vue&type=template&id=99b37716&scoped=true&"
import script from "./header-bread-crumb.vue?vue&type=script&lang=js&"
export * from "./header-bread-crumb.vue?vue&type=script&lang=js&"
import style0 from "./header-bread-crumb.vue?vue&type=style&index=0&id=99b37716&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b37716",
  null
  
)

export default component.exports